// extracted by css-extract-rspack-plugin
export default {"clickable":"Ky4ewK","spacer":"nmwL4i","page":"zLJJLb","map":"Sejlcp","loadingMask":"aY7oUs"};